export type ColumnsDefTypes = {
  id: number
  label: string
  name: string
  translationId: number
  sortable: boolean
}

export const MobileColumnSchema: ColumnsDefTypes[] = [
  { id: 1, name: 'pool', translationId: 999, sortable: true, label: '' },
  { id: 2, name: 'earned', translationId: 1072, sortable: true, label: 'Earned' },
  { id: 3, name: 'apr', translationId: 736, sortable: true, label: 'APR' },
  { id: 4, name: 'staked', translationId: 999, sortable: true, label: 'Your Staked' },
  { id: 5, name: 'endTime', translationId: 999, sortable: true, label: 'End Time' },
  { id: 6, name: 'details', translationId: 999, sortable: true, label: '' },
]

export const DesktopColumnSchema: ColumnsDefTypes[] = [
  { id: 1, name: 'pool', translationId: 999, sortable: true, label: '' },
  { id: 2, name: 'earned', translationId: 1072, sortable: true, label: 'Earned' },
  { id: 3, name: 'apr', translationId: 736, sortable: true, label: 'APR' },
  { id: 4, name: 'staked', translationId: 999, sortable: true, label: 'Your Staked' },
  { id: 5, name: 'endTime', translationId: 999, sortable: true, label: 'End Time' },
  { id: 6, name: 'details', translationId: 999, sortable: true, label: '' },
]
